// ====================================================================
// ACTORS — the multiplayer door, held open
// ====================================================================
// Every moving thing in the world — the player, each wolf, each Shell
// Shocker, SKULLFACE — registers here with an ID and its plain state object.
// Nothing queries this registry yet; it exists so that no system ever again
// gets written assuming "Chocky is the only actor" (the design plan's
// cheap-now/rewrite-later trade).
//
// The contract for future work (presence, the creature framework):
//   - state is PLAIN DATA (positions, facing, behaviour state). Renderers
//     read from it; they don't own it. Today's creatures still carry their
//     mesh refs inside their state objects — the creature framework migrates
//     those out; the IDs and this registry are already in place.
//   - anything that spawns an actor must despawn it (spawnActor's return
//     value is the handle).
let nextId = 1;

export const actors = new Map();    // id -> { id, kind, state }

export function spawnActor(kind, state) {
  const actor = { id: nextId++, kind, state };
  actors.set(actor.id, actor);
  return actor;
}

export function despawnActor(actor) {
  if (actor) actors.delete(actor.id);
}
